<script>
	import { breakpoint, platform, orientation } from "./MediaQuerySsr.svelte";
	import legend from "../images/legend.svg";
	// import legendMobile from "../images/legend_mobile.svg";
	// import legendDesktop from "../images/legend_desktop.svg";
</script>

<div class="legend">
	<div class="text">
		<div class="main">Lehrversorgung</div>
		<div class="sub">in % vom Richtwert</div>
	</div>
	<div class="image">
		<!-- <img src={$platform === "mobile" ? legendMobile : legendDesktop} /> -->
		<img src={legend} />
	</div>
</div>

<style lang="scss">
	.legend {
		display: flex;

		@media (min-width: #{$breakpoint-tablet-l + 1px}),
    (min-width: #{$breakpoint-mobile-l + 1px}) and (max-width: $breakpoint-tablet-s) {
			align-items: center;
		}

		@media (min-width: #{$breakpoint-tablet-s + 1px}) and (max-width: $breakpoint-tablet-l), (max-width: $breakpoint-mobile-l) {
			flex-direction: column;

			.text {
				display: flex;
			}
		}
	}

	.text {
		font-size: 12px;
		letter-spacing: 0.6px;
		text-transform: uppercase;
		opacity: 0.7;
		margin-right: 20px;
		white-space: nowrap;

		.main {
			font-weight: $medium;
		}

		.sub {
			margin-left: 4px;
		}
	}

	.image img {
		width: 100%;
		max-width: 364px;
	}
</style>
